export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            关于樱花漫画
          </h2>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
            <p>
              樱花漫画网是一个专注韩漫、日漫、国漫的免费漫画阅读平台，致力于为漫画爱好者提供最流畅、最全面的阅读体验。我们采用创新的下拉式阅读模式，让读者无需频繁翻页，一滑到底即可畅享完整漫画章节。
            </p>
            <p>
              平台收录超过三万部漫画作品，涵盖恋爱、热血、悬疑、搞笑、奇幻等多种题材，每日更新热门连载，确保读者不错过任何精彩内容。无论是经典长篇还是新锐佳作，樱花漫画都力求第一时间呈现。
            </p>
            <p>
              樱花漫画坚持全本免费原则，所有漫画资源均可无限制阅读，不设付费墙和隐藏收费。同时支持智能收藏、阅读进度同步和更新提醒，让追更变得简单高效。我们相信，好的漫画作品应该被更多人看到，这也是樱花漫画始终不变的初心。
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/70">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">30,000+</div>
              <div className="text-xs text-foreground-500 mt-1">漫画作品</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-600 font-heading">每日更</div>
              <div className="text-xs text-foreground-500 mt-1">持续连载</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-secondary-600 font-heading">免费</div>
              <div className="text-xs text-foreground-500 mt-1">全本阅读</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">3大品类</div>
              <div className="text-xs text-foreground-500 mt-1">韩漫日漫国漫</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}